var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export function ForbiddenPage() {
    return (_jsxs("div", __assign({ style: { textAlign: 'center', marginTop: '4rem' } }, { children: [_jsx("h1", { children: "403 - Access Denied" }), _jsx("p", { children: "Please open a ticket on the PLS support board/help desk to request access to perform this action." })] })));
}
